module.exports = __webpack_public_path__ + "img/pc-add-doc.88ebe18f.svg";